import { MutationTree } from 'vuex';
import { FormState } from './types';

export enum MutationTypes {
    SET_IS_VISIBLE_FORM = 'SET_IS_VISIBLE_FORM',
    SET_WAS_CLICKED_ON_SHOW_RESULT_PAGE = 'SET_WAS_CLICKED_ON_SHOW_RESULT_PAGE',
    SET_SHOW_RESULT_PAGE = 'SET_SHOW_RESULT_PAGE',
    SET_LABELS = 'SET_LABELS',
    SET_ICONS = 'SET_ICONS',
    SET_IMAGES = 'SET_IMAGES',
    SET_SETTINGS = 'SET_SETTINGS',
    SET_IS_VALID = 'SET_IS_VALID',
    SET_IS_TOUCHED = 'SET_IS_TOUCHED',
    SET_IS_RESSETING_FORM = 'SET_IS_RESSETING_FORM',
    SET_HAS_DEFAULT_VALUES = 'SET_HAS_DEFAULT_VALUES',
    UPDATE_DATA = 'UPDATE_DATA',
    UPDATE_INPUTS = 'UPDATE_INPUTS',
    UPDATE_FUNNEL_STEP = 'UPDATE_FUNNEL_STEP',
    UPDATE_FUNNEL_STEP_EXTRA = 'UPDATE_FUNNEL_STEP_EXTRA',
    UPDATE_LOCATION = 'UPDATE_LOCATION',
    DELETE_DATA = 'DELETE_DATA',
    RESET_FUNNEL_STEP = 'RESET_FUNNEL_STEP',
    RESET_FUNNEL_STEP_EXTRA = 'RESET_FUNNEL_STEP_EXTRA'
}

export type Mutations<S = FormState> = {
    [MutationTypes.SET_IS_VISIBLE_FORM]: (state: S, isVisibleForm: boolean) => void,
    [MutationTypes.SET_WAS_CLICKED_ON_SHOW_RESULT_PAGE]: (state: S, wasClickedOnShowResultButton: boolean) => void,
    [MutationTypes.SET_SHOW_RESULT_PAGE]: (state: S, showResultPage: boolean) => void,
    [MutationTypes.SET_LABELS]: (state: S, labels: Object) => void,
    [MutationTypes.SET_ICONS]: (state: S, icons: Object) => void,
    [MutationTypes.SET_IMAGES]: (state: S, images: Object) => void,
    [MutationTypes.SET_SETTINGS]: (state: S, settings: Object) => void,
    [MutationTypes.SET_IS_VALID]: (state: S, isValid: boolean) => void,
    [MutationTypes.SET_IS_TOUCHED]: (state: S, isTouched: boolean) => void,
    [MutationTypes.SET_IS_RESSETING_FORM]: (state: S, isResettingForm: boolean) => void,
    [MutationTypes.SET_HAS_DEFAULT_VALUES]: (state: S, hasDefaultValues: boolean) => void,
    [MutationTypes.UPDATE_DATA]: (state: S, payload: Object) => void,
    [MutationTypes.UPDATE_INPUTS]: (state: S, payload: Object) => void,
    [MutationTypes.UPDATE_FUNNEL_STEP]: (state: S, payload: Object) => void,
    [MutationTypes.UPDATE_FUNNEL_STEP_EXTRA]: (state: S, payload: Object) => void,
    [MutationTypes.UPDATE_LOCATION]: (state: S, payload: Object) => void,
    [MutationTypes.DELETE_DATA]: (state: S, payload: Object) => void,
    [MutationTypes.RESET_FUNNEL_STEP]: (state: S) => void,
    [MutationTypes.RESET_FUNNEL_STEP_EXTRA]: (state: S) => void
}

export const mutations: MutationTree<FormState> = {
    [MutationTypes.SET_IS_VISIBLE_FORM]: (state, isVisibleForm) => {
        state.isVisibleForm = isVisibleForm;
    },
    [MutationTypes.SET_WAS_CLICKED_ON_SHOW_RESULT_PAGE]: (state, wasClickedOnShowResultButton) => {
        state.wasClickedOnShowResultButton = wasClickedOnShowResultButton;
    },
    [MutationTypes.SET_SHOW_RESULT_PAGE]: (state, showResultPage) => {
        state.showResultPage = showResultPage;
    },
    [MutationTypes.SET_LABELS]: (state, labels) => {
        state.labels = labels;
    },
    [MutationTypes.SET_ICONS]: (state, icons) => {
        state.icons = icons;
    },
    [MutationTypes.SET_IMAGES]: (state, images) => {
        state.images = images;
    },
    [MutationTypes.SET_SETTINGS]: (state, settings) => {
        state.settings = settings;
    },
    [MutationTypes.UPDATE_LOCATION]: (state, payload) => {
        state.location[payload.key] = payload.value;
    },
    [MutationTypes.UPDATE_DATA]: (state, payload) => {
        if (payload.key) {
            state.data[payload.field][payload.key] = payload.value;
        } else {
            state.data[payload.field] = payload.value;
        }
    },
    [MutationTypes.UPDATE_INPUTS]: (state, payload) => {
        state.inputs[payload.field][payload.key] = payload.value;
    },
    [MutationTypes.DELETE_DATA]: (state, payload) => {
        delete state.data[payload.field][payload.key][payload.value];
    },
    [MutationTypes.SET_IS_VALID]: (state, isValid) => {
        state.isValid = isValid;
    },
    [MutationTypes.SET_IS_TOUCHED]: (state, isTouched) => {
        state.isTouched = isTouched;
    },
    [MutationTypes.SET_IS_RESSETING_FORM]: (state, isResettingForm) => {
        state.isResettingForm = isResettingForm;
    },
    [MutationTypes.SET_HAS_DEFAULT_VALUES]: (state, hasDefaultValues) => {
        state.hasDefaultValues = hasDefaultValues;
    },
    [MutationTypes.UPDATE_FUNNEL_STEP]: (state, payload) => {
        state.funnelStep[payload.key] = payload.value;
    },
    [MutationTypes.UPDATE_FUNNEL_STEP_EXTRA]: (state, payload) => {
        state.funnelStepExtraData[payload.key] = payload.value;
    },
    [MutationTypes.RESET_FUNNEL_STEP]: (state, payload) => {
        state.funnelStep = {
            properties: {
                stepProcessed: 'start',
                stepProcessedNum: 1,
                stepURL: window.location.href,
                referrerURL: window.location.href,
                funnelName: 'Gebrauchtfahrzeugwerte',
                funnelCategory: 'B2C',
                zipCode: '',
                initialRegistrationYear: '',
                initialRegistrationMonth: '',
                mileage: '',
                certificateAvailable: '',
                carType: '',
                manufacturer: '',
                carModel: '',
                carModelType: '',
                numberOfDoors: '',
                fuelType: '',
                power: '',
                engine: '',
                driveType: '',
                transmissionType: '',
                transmissionModel: '',
                carModel_precise: '',
                carModelVersion: '',
                constructionYearFrom: '',
                constructionYearTo: '',
                estimatedCarValue: '',
                certificateAvailableHsn: '',
                certificateAvailableTsn: '',
            }
        };
    },
    [MutationTypes.RESET_FUNNEL_STEP_EXTRA]: (state, payload) => {
        state.funnelStepExtraData = {};
    }
};